import { Bg1, Bg2, Bg3, svgCard } from '../../../assets'
import './index.css'
import ReactText from '../../../component/React'
import React, { useEffect, useRef } from 'react';
import { keyframes, styled } from 'styled-components';
import { H1, MediumText } from '../../../component/styles/Text';
import { WhatsApp } from '@mui/icons-material'

const Home = () => {
  const cardRef = useRef(null);

  useEffect(() => {
    const cardElement = cardRef.current;
    if (!cardElement) return;

    let timeoutId;

    const handleMouseEnter = () => {
      clearTimeout(timeoutId);
      cardElement.classList.add('hovered');
    };

    const handleMouseLeave = () => {
      timeoutId = setTimeout(() => {
        cardElement.classList.remove('hovered');
      }, 3000);
    };

    cardElement.addEventListener('mouseenter', handleMouseEnter);
    cardElement.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      clearTimeout(timeoutId);
      cardElement.removeEventListener('mouseenter', handleMouseEnter);
      cardElement.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  return (
    <div className='body1' id="#">
      <div className="body">
        <div
          data-aos="fade-right"
          data-aos-offset="200"
          data-aos-delay="50"
          data-aos-duration="1000"
          className="Content">
          <TextWrapper>
            <Title>Learn<br />and Code <ReactText /> Apps</Title>
            <Description className='text-with-shadow'>Don't skip design. Learn design and code, by building real apps with React and React Native. Complete courses about the best tools.</Description>

            <a
              className="btn"
              href="https://wa.me/+923110241969"
              target="_blank"
              rel="noopener noreferrer"
            >
              <WhatsApp htmlColor='#25D366' style={{ height: 44, width: 44 }} className='RightArrow' />
              <span className="btnText text-with-shadow">Get Started</span>
            </a>
          </TextWrapper>
        </div>

        <div
          data-aos="fade-left"
          data-aos-offset="200"
          data-aos-delay="50"
          data-aos-duration="1000"
          className="card-div">
          <div className="card-hover-controll" ref={cardRef}>
            <div className="cards2div">
              <img src={svgCard} className="TOP-bg2" alt="" aria-hidden="true" />
              <img src={svgCard} className="TOP-bg3" alt="" aria-hidden="true" />
            </div>
            <img src={Bg1} className="bg1" alt="" aria-hidden="true" />
            <div className="cards2div">
              <img src={Bg2} className="bg2" alt="" aria-hidden="true" />
              <img src={Bg3} className="bg3" alt="" aria-hidden="true" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home

const animation = keyframes`
    0% { opacity: 0; transform: translateY(-10px); filter: blur(10px); }
    30% { opacity: 0.5; transform: translateY(-10px); filter: blur(10px); }
    100% { opacity: 1; transform: translateY(0px); filter: blur(0px); }
`;

const TextWrapper = styled.div`
    max-width: 460px;
    display: grid;
    gap: 24px;
    color:#F2F5FF;

    > * {
        opacity: 0;
        animation: ${animation} 1s forwards;

        :nth-child(1) {
            animation-delay: 0s;
        }
        :nth-child(2) {
            animation-delay: 0.2s;
        }
        :nth-child(3) {
            animation-delay: 0.4s;
        }
    }
`;
const Title = styled(H1)`
    background: linear-gradient(180deg, #46AEFE 0%, #F2F5FF 100%);
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
`;
const Description = styled(MediumText)`
    color: rgba(242, 245, 255, 0.92);
    max-width: 440px;
`;
